<template>
	<nav class="navbar navbar-expand-sm navbar-dark bg-dark" role="navigation">
		<div class="container">
			<!-- Brand and toggle get grouped for better mobile display -->
			<router-link to="/" class="navbar-brand mr-auto">Indibating</router-link>
			<button
					class="navbar-toggler"
					type="button"
					data-toggle="collapse"
					data-target="#navbarTop"
					aria-controls="navbarTop"
					aria-expanded="false"
					aria-label="Toggle navigation"
					@click="toggleNavbar">
				<span class="navbar-toggler-icon"></span>
			</button>

			<div class="collapse navbar-collapse" id="navbarTop" :class="{show: isNavOpen}">
				<ul class="navbar-nav mr-auto">
					<router-link to="/account" tag="li" class="nav-item"><a class="nav-link">My Account</a></router-link>
				</ul>
				<ul class="nav navbar-nav">
					<router-link to="/login" tag="li" v-if="!isLoggedIn" class="nav-item" active-class="active">
						<a class="nav-link">Login</a>
					</router-link>
					<li v-if="isLoggedIn" class="li-pointer nav-item">
						<a @click="logout" class="nav-link">Logout {{ userEmail }}</a>
					</li>
					<router-link to="/register" tag="li" v-if="!isLoggedIn" class="nav-item" active-class="active">
						<a class="nav-link">Register</a>
					</router-link>
					<li v-if="$store.getters.isLoggedIn && isAdmin">
						<router-link to="/admin" style="margin-left: 10px" class="btn btn-warning navbar-btn" tag="button">
							Admin
						</router-link>
					</li>
				</ul>
			</div>
		</div>
		<!-- /.container -->
	</nav>
</template>

<script>
	import {
		mapActions, mapGetters
	} from 'vuex';

	export default {
		data() {
			return {
				isNavOpen: false
			}
		},
		computed: {
			...mapGetters(['isLoggedIn', 'currentUser']),
			userEmail() {
				return this.isLoggedIn ? this.currentUser.email : ''
			},
			isAdmin() {
				if(this.currentUser.email == 'admin@gmail.com') {
					console.log('current user is admin');
					return true;
				} else {
					console.log('current user is not admin');
					return false;
				}
			}
		},
		methods: {
			...mapActions(['logout']),
			toggleNavbar() {
				this.isNavOpen = !this.isNavOpen
			}
		},
		created() {
		}
	}
</script>


<style scoped lange="sass">
	.navbar-btn a {
		color: white;
	}

	.li-pointer {
		cursor: pointer;
	}

	.li-pointer:hover {
		cursor: pointer;
	}
</style>
